import { wealthProApi } from '../../redux/api';

const masterAccountApiEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchMasterAccounts: builder.query({
            query: ({ sort, page, pageLimit, ...filters }) => ({
                url: `api/clientsearch/master-accounts`,
                method: 'POST',
                body: {
                    sort,
                    page,
                    limit: pageLimit,
                    ...filters
                }
            }),
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName
            },
            merge: (currentCache, newItems) => {
                const { pagination: currPage } = currentCache || {};
                const { pagination: nextPage } = newItems || {};

                if (!currPage || nextPage.page <= currPage.page) {
                    return newItems;
                }

                currentCache.pagination = newItems.pagination;
                currentCache.results.push(...newItems.results)
            },
            forceRefetch({ currentArg, previousArg }) {
                const { page: currPage } = currentArg || { page: 1 };
                const { page: prevPage } = previousArg || { page: 0 };
                return currPage !== prevPage;
            },
        }),
        fetchMasterAccountsList: builder.query({
            query: ({ sort, page, pageLimit }) => ({
                url: `api/clientsearch/master-accounts/list`,
                method: 'POST',
                body: {
                    sort,
                    page,
                    limit: pageLimit
                }
            }),
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName
            },
            merge: (currentCache, newItems) => {
                const { pagination: currPage } = currentCache || {};
                const { pagination: nextPage } = newItems || {};

                if (!currPage || nextPage.page <= currPage.page) {
                    return newItems;
                }

                currentCache.pagination = newItems.pagination;
                currentCache.results.push(...newItems.results)
            },
            forceRefetch({ currentArg, previousArg }) {
                const { page: currPage } = currentArg || { page: 1 };
                const { page: prevPage } = previousArg || { page: 0 };
                return currPage !== prevPage;
            },
        }),
        createSetFromClients: builder.mutation({
            query: (body) => ({
                url: `api/clientsearch/master-accounts/client-set`,
                method: 'POST',
                body
            })
        }),

        getMasterAccountSummary: builder.query({
            query: (masterAccountId) => `api/clientsearch/master-accounts/${masterAccountId}/summary`,
            
        })
    })
});

export const {
    useFetchMasterAccountsQuery,
    useFetchMasterAccountsListQuery,
    useLazyFetchMasterAccountsQuery,
    useLazyFetchMasterAccountsListQuery,
    useCreateSetFromClientsMutation,
    useGetMasterAccountSummaryQuery
} = masterAccountApiEndpoints;